export const CANDIDATE_LANGUAGES_FIELDS = {
    english: {title: 'Tiếng Anh', type: "option", isMulti: true},
    english_note: {title: 'Note TA', type: "text"},
    france: {title: 'Tiếng Pháp', type: "option", isMulti: true},
    france_note: {title: 'Note T.Pháp', type: "text"},
    china: {title: 'Tiếng Trung', type: "option", isMulti: true},
    china_note: {title: 'Note T.Trung', type: "text"},
    korea: {title: 'Tiếng Hàn', type: "option", isMulti: true},
    korea_note: {title: 'Note T.Hàn', type: "text"},
    japanese: {title: 'Tiếng Nhật', type: "option", isMulti: true},
    japanese_note: {title: 'Note TN', type: "text"},
    russian: {title: 'Tiếng Nga', type: "option", isMulti: true},
    russian_note: {title: 'Note T.Nga', type: "text"},
    others: {title: 'Ngôn ngữ khác', type: "text"},
    common_notes: {title: 'Notes chung', type: "text"}
}

export const RC_CANDIDATE_LANGUAGES_FIELDS = {
    rc_english: {title: 'Tiếng Anh (RC)', type: "option", isMulti: true},
    rc_france: {title: 'Tiếng Pháp (RC)', type: "option", isMulti: true},
    rc_china: {title: 'Tiếng Trung (RC)', type: "option", isMulti: true},
    rc_korea: {title: 'Tiếng Hàn (RC)', type: "option", isMulti: true},
    rc_japanese: {title: 'Tiếng Nhật (RC)', type: "option", isMulti: true},
    rc_russian: {title: 'Tiếng Nga (RC)', type: "option", isMulti: true},
    rc_others: {title: 'Ngôn ngữ khác (RC)', type: "text"},
    rc_common_notes: {title: 'Notes chung (RC)', type: "text"}
}

export const LANGUAGE_SKILL_OPTIONS = [
    {value: 'n/a', label: 'N/A'},
    {value: 'cao cấp - theo cv', label: 'Cao cấp - theo CV'},
    {value: 'trung cấp - theo cv', label: 'Trung cấp - theo CV'},
    {value: 'sơ cấp - theo cv', label: 'Sơ cấp - theo CV'},
    {value: 'can use - theo cv (kqbt)', label: 'Can use - theo CV (kqbt)'},
    {value: 'fluent 4 kỹ năng', label: 'fluent 4 kỹ năng'},
    {value: 'cơ bản', label: 'cơ bản'},
    {value: 'nghe nói', label: 'nghe nói'},
    {value: 'đọc viết', label: 'đọc viết'},
    {value: 'nghe nói chuyên môn', label: 'nghe nói chuyên môn'},
    {value: 'đọc viết chuyên môn', label: 'đọc viết chuyên môn'},
    {value: 'can not use', label: 'CAN NOT USE'},
    {value: 'others', label: 'others'},
]